import React from 'react';

import { SEO } from 'main/components';
import {
  FutureProof,
  Landing,
  Optimized,
  OrqaIntegration,
  Visualisation,
  CTA,
} from 'modules/rapidFire';

export const RapidFire = () => {
  return (
    <>
      <SEO seoTitle="ImmersionRC rapidFIRE - 5.8GHz Video Receiver - Orqa" />
      <section className="rapid-fire-section">
        <Landing />
        <Visualisation />
        <FutureProof />
        <Optimized />
        <OrqaIntegration />
        <CTA />
      </section>
    </>
  );
};
